import React, { useState, useEffect } from "react";
import axios from "axios";
import Loading from "../../Student/Reusablecomponents/Loading";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { useNavigate, useLocation } from "react-router-dom";
import {
  GetScenarioDetails,
  GetScienceQuestionDetails,
  GetEnglishQuestionDetails,
  GetQuestionDetails,
  GetEnglishScenarioDetails,
} from "../../ReusableComponents/CommonApis";
import { useSelector, useDispatch } from "react-redux";
const QBVerify = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );

  const [QBMVDetails, SetQBMVDetails] = useState();
  const [Load, SetLoad] = useState(false);

  useEffect(() => {
    QuestionVerificationStatus();
  }, []);

  const QuestionVerificationStatus = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetQuestionsByVerificationStatus?QuestionVerificationStatus=${location.state?.QVS}&SubjectId=${items?.subjectId}&QBCreatorUserId=${location.state?.CreatedBy}&QBCategoryCode=${location.state?.Tab}&RepType=Overall&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetQBMVDetails(res.data);
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const QVStatusColumns = [
    ...(location?.state?.QVS === 0
      ? [
          {
            name: "Question Verification Status",
            selector: "lovDescription",
            sortable: true,
          },
        ]
      : []),
    ...(location.state?.Tab !== "DQ"
      ? [
          {
            name: "Scenario Id",
            selector: "scenarioID",
            sortable: true,
            cell: (row) => (
              <div
                className="LinkStyles"
                onClick={() => NavigateScenario(row.scenarioID, true)}
              >
                {row.scenarioID ? row.scenarioID : ""}{" "}
              </div>
            ),
          },
        ]
      : []),

    {
      name: "Question Id",
      selector: "questionId",
      sortable: true,
      cell: (row) => (
        <div
          className="LinkStyles"
          onClick={() => {
            if (location.state?.Tab !== "DQ" && row.scenarioID) {
              NavigateScenario(row.scenarioID, false, true);
              NavigateQuestion(row.questionId, false);
            } else {
              NavigateQuestion(row.questionId, true);
            }
          }}
        >
          {row.questionId}{" "}
        </div>
      ),
    },
   ...(items?.subjectId === "1" ? [{ name: "Orginal / Cloned", selector: "isCloneOrOriginal", sortable: true }] :[]),
  ];

  const NavigateQuestion = (QId, Scenario) => {
    console.log(items?.subjectId);
    switch (items?.subjectId) {
      case "1":
        GetQuestionDetails(
          SelectLanguage,
          QId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Scenario
        );
        break;
      case "2":
        GetScienceQuestionDetails(
          SelectLanguage,
          QId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Scenario
        );
        break;
      default:
        GetEnglishQuestionDetails(
          QId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Scenario
        );
        break;
    }
  };

  const NavigateScenario = (SId, Scenario, Naviagtion) => {
    switch (true) {
      case ["3", "4", "5"].includes(items?.subjectId):
        GetEnglishScenarioDetails(
          SId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Scenario,
          Naviagtion
        );
        break;
      default:
        GetScenarioDetails(
          SelectLanguage,
          SId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Naviagtion
        );
        break;
    }
  };

  return (
    <>
      <div className="SubHeading mt-3">
        {" "}
        Questions List -{" "}
        {location.state?.QVS ? QBMVDetails?.[0]?.lovDescription : "All"}
      </div>
      <div className="Card mt-2">
        {QBMVDetails ? (
          <DataTable
            data={QBMVDetails}
            columns={QVStatusColumns}
            Dropdownvalues={["10", "20", "50", "100"]}
            className="NCLDataTable"
            ShowPagination="true"
            ShowPagecount="true"
          />
        ) : (
          <div className="NoData-Message">
            {" "}
            {process.env.REACT_APP_Nodata_Found}{" "}
          </div>
        )}
      </div>
      {Load && <Loading />}
    </>
  );
};
export default QBVerify;
